import { getCustomerEligibility } from '../api/SlmService';
import { markCandidateAsContacted } from './markCandidateAsContacted';

export const sendSmsToCandidate = async (phoneNumber, candidateId) => {
  const response = await getCustomerEligibility();
  const customer = response?.data?.cicCustomer || {};

  const smsBody = `Hello, this is ${customer?.user?.firstName} with ${customer?.businessName}. I found your information on The Home Depot Path to Pro Network and wanted to reach out about a potential job opportunity. Would you be open to discussing this via text?
Msg & data rates may apply. Reply STOP to end messages from ${customer?.businessName}. For HELP, email Path_to_Pro@homedepot.com`;

  const smsHref = `sms:${phoneNumber}?body=${encodeURIComponent(smsBody)}`;
  markCandidateAsContacted(candidateId, 'text');
  window.location.href = smsHref;
};
